import mockArtistsData from "../data/mockData/artistsData";
import { enrichArtistRow } from "./artistStoreDetails";

const STORAGE_ARTISTS = "wl_bs_artists_extras";

function readSessionArtistExtras() {
  if (typeof sessionStorage === "undefined") {
    return [];
  }
  try {
    const raw = sessionStorage.getItem(STORAGE_ARTISTS);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function mergeArtistsById(baseRows, extras) {
  const byId = new Map(baseRows.map(row => [String(row.id), row]));
  extras.forEach(row => {
    const id = String(row.id);
    byId.set(id, { ...byId.get(id), ...row });
  });
  return Array.from(byId.values());
}

function readDeletedArtistIds() {
  if (typeof sessionStorage === "undefined") {
    return new Set();
  }
  try {
    const raw = sessionStorage.getItem("wl_bs_artists_deleted");
    const parsed = raw ? JSON.parse(raw) : [];
    return new Set((Array.isArray(parsed) ? parsed : []).map(String));
  } catch {
    return new Set();
  }
}

/** Merged seed + session artist rows, excluding demo deletes. */
export function getArtistRows() {
  const merged = mergeArtistsById(mockArtistsData, readSessionArtistExtras());
  const deleted = readDeletedArtistIds();
  return merged
    .filter(row => row && row.id != null && !deleted.has(String(row.id)))
    .map(enrichArtistRow)
    .sort((a, b) => Number(a.id) - Number(b.id));
}

/** JSON-safe rows for clipboard export (e.g. updating artistsData.js). */
export function getArtistMockExportPayload() {
  return getArtistRows();
}

/** Resolve Spotify identifier for a catalog artist id (mock seed + session extras). */
export function getArtistSpotifyIdentifierById(artistId) {
  if (artistId == null || artistId === "") {
    return "";
  }
  const merged = mergeArtistsById(mockArtistsData, readSessionArtistExtras());
  const artist = merged.find(row => String(row.id) === String(artistId));
  const spotifyId = artist?.spotify_identifier;
  return spotifyId != null && spotifyId !== "" ? String(spotifyId).trim() : "";
}
